module.exports = __webpack_public_path__ + "a19240f60581e10a25ee91cc4c00c3ed.svg";